<ng-container *ngIf="userDeferDialog().show">
   <div
      class="defer-overlay"
      (click)="closeUserDeferDialog()">
      <div
         class="defer-dialog"
         (click)="$event.stopPropagation()">
         <div class="defer-modal-title">Request a deferral</div>
         <p class="defer-modal-subtitle">
            <span *ngIf="!isAutoApprovedDeferral">
               This request will be sent to an admin for review. Your team member will not be deferred until it is approved.
            </span>
            <span *ngIf="isAutoApprovedDeferral">
               This deferral is approved on submit. The review moves out of its current type and into the Open Cycle.
            </span>
         </p>

         <p class="defer-prompt">Reason Category</p>
         <div
            class="defer-category-trigger"
            [class.open]="deferCategoryOpen"
            (click)="deferCategoryOpen = !deferCategoryOpen">
            <span
               *ngIf="!deferReasonCategory"
               class="defer-category-placeholder">
               Select a reason…
            </span>
            <span
               *ngIf="deferReasonCategory"
               class="defer-category-selected">
               {{ deferReasonCategory }}
            </span>
            <i
               class="fa fa-chevron-down defer-category-chevron"
               [class.rotated]="deferCategoryOpen"></i>
         </div>

         <div
            class="defer-category-dropdown"
            *ngIf="deferCategoryOpen">
            <div
               *ngFor="let opt of deferCategoryOptions"
               class="defer-category-option"
               [class.selected]="deferReasonCategory === opt.label"
               (click)="selectDeferCategory(opt.label)">
               <div class="defer-category-option-title">{{ opt.label }}</div>
               <div class="defer-category-option-desc">{{ opt.description }}</div>
            </div>
         </div>

         <p
            class="defer-prompt"
            [style.opacity]="(!needsAdminApproval && !canSelectDeferQuarter) || deferQuarter == '1 Year' ? '0.4' : '1'">
            When Should This Review be Completed?
         </p>

         <div class="defer-quarter-strip">
            <div
               [class.disabled]="!needsAdminApproval"
               class="defer-quarter-option"
               [class.selected]="!deferQuarter"
               (click)="selectDeferQuarter(null)">
               <div class="defer-quarter-label">Needs Admin Review</div>
            </div>
            <div
               *ngFor="let q of deferQuarterOptions"
               class="defer-quarter-option"
               [class.selected]="deferQuarter === q.value"
               [class.disabled]="!canSelectDeferQuarter || deferQuarter == '1 Year'"
               [title]="canSelectDeferQuarter ? '' : 'Available for extended leave of absence or insufficient time under current manager'"
               (click)="selectDeferQuarter(q.value)">
               <div class="defer-quarter-label">{{ q.label }}</div>
               <div class="defer-quarter-sub">{{ q.sub }}</div>
            </div>
         </div>

         <p
            class="defer-prompt"
            style="margin-top: 18px">
            Additional Details
         </p>
         <textarea
            class="defer-textarea"
            [(ngModel)]="deferReason"
            placeholder="Explain why you are requesting a deferral…"
            rows="4"></textarea>

         <div class="defer-footer">
            <p
               class="defer-footer-note"
               [class.auto]="isAutoApprovedDeferral">
               <i
                  class="fa"
                  [class.fa-bolt]="isAutoApprovedDeferral"
                  [class.fa-user]="!isAutoApprovedDeferral"></i>
               <span *ngIf="isAutoApprovedDeferral">Auto-approves and moves the review to Open Cycle</span>
               <span *ngIf="!isAutoApprovedDeferral">An admin will review this request</span>
            </p>
            <div class="defer-footer-buttons">
               <button
                  class="v-button v-button-md v-white"
                  (click)="closeUserDeferDialog()"
                  [disabled]="isSubmittingUpdate">
                  Cancel
               </button>
               <button
                  class="v-button v-button-md v-green"
                  (click)="onUserDeferSubmit()"
                  [disabled]="!deferReasonCategory || !deferReason?.trim() || isSubmittingUpdate">
                  <span *ngIf="!isSubmittingUpdate">Submit Request</span>
                  <span
                     *ngIf="isSubmittingUpdate"
                     class="spinnerSave"></span>
               </button>
            </div>
         </div>
      </div>
   </div>
</ng-container>

<!-- User follow-up dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="userFollowUpDialog().show"
   (click)="closeUserFollowUpDialog()"></div>
<div
   class="um-dialog fu-dialog"
   *ngIf="userFollowUpDialog().show">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">Follow-up for {{ userFollowUpDialog().row?.name }}</div>
         <div class="fu-subtitle">{{ userFollowUpDialog().row?.practice }}</div>
      </div>
      <button
         class="rp-modal-close"
         (click)="closeUserFollowUpDialog()"
         title="Close">
         ✕
      </button>
   </div>

   <div class="fu-body">
      <div
         class="loading"
         *ngIf="userFollowUpLoading">
         Loading messages…
      </div>
      <ng-container *ngIf="!userFollowUpLoading">
         <div class="fu-message fu-message--user">
            <div class="fu-message-avatar fu-message-avatar--user">
               <i class="fa fa-user"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">{{ userFollowUpDialog().row?.name }}</span>
                  <span class="fu-message-time">{{ userFollowUpDeferredOn | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div class="fu-message-bubble fu-message-bubble--user">
                  {{ userFollowUpDialog().row?.deferReason || "No reason provided." }}
               </div>
            </div>
         </div>

         <div
            *ngFor="let msg of userFollowUpMessages"
            [class]="msg.isAdmin ? 'fu-message fu-message--admin' : 'fu-message fu-message--user-reply'">
            <div [class]="msg.isAdmin ? 'fu-message-avatar fu-message-avatar--admin' : 'fu-message-avatar fu-message-avatar--user'">
               <i [class]="msg.isAdmin ? 'fa fa-hospital-user' : 'fa fa-user'"></i>
            </div>
            <div class="fu-message-content">
               <div class="fu-message-meta">
                  <span class="fu-message-author">Admin</span>
                  <span class="fu-message-time">{{ msg.sentOn | date: "M/d/yyyy h:mm a" }}</span>
               </div>
               <div [class]="msg.isAdmin ? 'fu-message-bubble fu-message-bubble--admin' : 'fu-message-bubble fu-message-bubble--user'">
                  {{ msg.message }}
               </div>
            </div>
         </div>

         <div
            class="fu-empty"
            *ngIf="userFollowUpMessages.length === 0">
            No follow-up messages yet.
         </div>
      </ng-container>
   </div>

   <div class="fu-footer">
      <textarea
         class="fu-textarea"
         [(ngModel)]="userFollowUpMessage"
         placeholder="Write a response…"
         rows="3"></textarea>
      <div class="fu-footer-actions">
         <button
            class="v-button v-button-md v-gray"
            (click)="closeUserFollowUpDialog()">
            Cancel
         </button>
         <button
            class="v-button v-button-md v-teal"
            [disabled]="!userFollowUpMessage?.trim() || userFollowUpSaving"
            (click)="sendUserFollowUp()">
            {{ userFollowUpSaving ? "Sending…" : "Send" }}
         </button>
      </div>
   </div>
</div>

<!-- User reject dialog -->
<div
   class="um-dialog-backdrop"
   *ngIf="rejectedDialog().show"
   (click)="closeRejectedDialog()"></div>
<div
   class="um-dialog fu-dialog"
   style="width: 420px !important"
   *ngIf="rejectedDialog().show">
   <div class="fu-header">
      <div class="fu-header-info">
         <div class="fu-title">
            Deferral Request
            <i>Rejected</i>
         </div>
         <div class="fu-subtitle">Why was the deferral request for {{ rejectedDialog().row?.name }} rejected?</div>
      </div>
      <button
         class="rp-modal-close"
         (click)="closeRejectedDialog()"
         title="Close">
         ✕
      </button>
   </div>

   <div
      class="fu-body"
      style="min-height: unset !important; margin-bottom: 15px">
      <div
         class="fu-message fu-message--admin"
         style="margin-left: 0px">
         <div class="fu-message-content">
            <div class="fu-message-meta">
               <span class="fu-message-author">{{ rejectedDialogResolvedBy }}</span>
               <span class="fu-message-time">{{ rejectedDialogResolvedOn | date: "M/d/yyyy h:mm a" }}</span>
            </div>
            <div class="fu-message-bubble fu-message-bubble--admin">{{ rejectedDialogRejectReason }}</div>
         </div>
      </div>
   </div>
</div>

<ng-container *ngIf="userResponsibilitiesDialog().show">
   <div
      class="defer-overlay"
      (click)="closeAssignmentPanel(); closeUserResponsibilitiesDialog()">
      <div
         class="defer-dialog"
         style="width: 930px; overflow-y: auto"
         (click)="$event.stopPropagation()">
         <div class="responsibilities-modal-layout">
            <div class="responsibilities-main-panel">
               <div class="responsibilities-header">
                  <div class="defer-modal-title">
                     Additional Responsibilities for
                     <span style="color: #055f9b">{{ userResponsibilitiesDialog().row?.name }}</span>
                  </div>
                  <button
                     type="button"
                     class="teamModal__close"
                     aria-label="Close"
                     (click)="closeAssignmentPanel(); closeUserResponsibilitiesDialog()">
                     <i class="fas fa-close"></i>
                  </button>
               </div>
               <hr />

               <p
                  class="defer-modal-subtitle"
                  style="font-weight: 400; color: #1e1d1d; font-size: 14px; margin-bottom: 12px">
                  If applicable, list any significant responsibilities specific to this team member's role that are not already covered elsewhere.
                  <strong>Tip:</strong>
                  Use the
                  <strong>Preview</strong>
                  tab to see the question exactly as it will appear on the review.
                  <span style="font-style: italic">
                     &nbsp;Examples for Reference: Lead CSR/Tech duties, schedule creation, end-of-day responsibilities, inventory management,
                     training responsibilities, etc.
                  </span>
               </p>

               <div
                  class="resp-review-ref"
                  role="button"
                  tabindex="0"
                  (click)="openFullReviewPreview()"
                  (keydown.enter)="openFullReviewPreview()">
                  <div class="resp-review-ref-thumb"></div>
                  <div class="resp-review-ref-text">
                     <b>Not sure what's already covered? View the full review &rarr;</b>
                     <span>
                        Browse every question already on {{ userResponsibilitiesDialog().row?.name }}'s performance review before adding your own.
                     </span>
                     @if (!userResponsibilitiesDialog().row?.reviewType) {
                        <span
                           style="font-style: italic; display: block"
                           class="v-darkorangecolor">
                           ** Please go back & select a Review Type for this team member
                        </span>
                     }
                  </div>
               </div>

               <div
                  class="loading"
                  *ngIf="!isResponsibilitiesLoaded">
                  Loading responsibilities…
               </div>

               <ng-container *ngIf="isResponsibilitiesLoaded">
                  <div
                     class="defer-modal-subtitle"
                     *ngIf="responsibilityRows.length < 1"
                     style="margin-bottom: 18px; color: #666">
                     No additional responsibilities have been added yet.
                  </div>

                  <div class="responsibilities-list">
                     <div
                        class="responsibility-row"
                        *ngFor="let item of responsibilityRows; let i = index; trackBy: trackByResponsibility">
                        <div class="responsibility-row-header">
                           <div class="resp-card-tabs">
                              <button
                                 type="button"
                                 [class.on]="(item.activeTab || 'write') === 'write'"
                                 (click)="setResponsibilityTab(i, 'write')">
                                 <i class="fas fa-pen"></i>
                                 &nbsp;Write
                              </button>
                              <button
                                 type="button"
                                 [class.on]="item.activeTab === 'preview'"
                                 (click)="setResponsibilityTab(i, 'preview')">
                                 <i class="fas fa-eye"></i>
                                 &nbsp;Preview on review
                              </button>
                           </div>

                           <button
                              type="button"
                              class="v-button v-button-sm v-gray removeButton"
                              (click)="removeResponsibility(i)"
                              [disabled]="isSavingResponsibilities">
                              <i class="fas fa-remove"></i>
                              &nbsp;Remove
                           </button>
                        </div>

                        <ng-container *ngIf="(item.activeTab || 'write') === 'write'">
                           <vc-textarea
                              [label]="'Responsibility / Criteria Description'"
                              [(ngModel)]="item.responsibilityText"
                              (ngModelChange)="onResponsibilityTextChanged(i)"
                              [rows]="3"
                              [maxlength]="1000"
                              [disabled]="isSavingResponsibilities"
                              placeholder="Example: Responsible for inventory management and monthly supply ordering."></vc-textarea>

                           <div
                              class="resp-dup-hint"
                              *ngIf="item.dupMatch">
                              <b>
                                 <i class="fas fa-wand-magic-sparkles"></i>
                                 &nbsp;Heads up &mdash; this looks similar to an existing review question:
                              </b>
                              The AI check found overlap with a question already on this review.
                              <div class="resp-dup-match">&ldquo;{{ item.dupMatch }}&rdquo;</div>
                           </div>

                           <button
                              type="button"
                              class="assign-members-btn"
                              (click)="openAssignmentPanel(i)"
                              [disabled]="isSavingResponsibilities">
                              <i class="fas fa-users"></i>
                              &nbsp;Assign to multiple team members
                              <span style="font-size: 20px; line-height: 11px; vertical-align: text-top">→</span>
                              <span *ngIf="getAssignedCount(i)">({{ getAssignedCount(i) }})</span>
                           </button>
                        </ng-container>

                        <div
                           class="resp-preview-box"
                           *ngIf="item.activeTab === 'preview'">
                           <div
                              class="resp-q-label"
                              *ngIf="item.responsibilityText?.trim(); else respEmptyPreview">
                              {{ item.responsibilityText }}
                              <span class="resp-req">*</span>
                           </div>
                           <ng-template #respEmptyPreview>
                              <div class="resp-q-label resp-q-empty">Nothing written yet &mdash; switch back to Write.</div>
                           </ng-template>
                           <div class="resp-pills">
                              <span
                                 class="resp-pill"
                                 *ngFor="let opt of responsibilityPreviewOptions">
                                 {{ opt }}
                              </span>
                           </div>
                           <div class="resp-opt-notes">Optional notes</div>
                           <textarea
                              class="resp-notes-ta"
                              disabled
                              placeholder="Additional comments..."></textarea>
                        </div>
                     </div>
                  </div>

                  <button
                     type="button"
                     class="v-button v-button-md v-green"
                     style="margin-bottom: 80px"
                     (click)="addResponsibility()"
                     [disabled]="isSavingResponsibilities">
                     <i
                        class="fas fa-plus"
                        style="font-size: 12px"></i>
                     &nbsp;Add Responsibility
                  </button>
               </ng-container>

               <div class="responsibility-actions">
                  <div style="display: flex; gap: 10px">
                     <button
                        class="v-button v-button-md v-white"
                        (click)="closeAssignmentPanel(); closeUserResponsibilitiesDialog()"
                        [disabled]="isSavingResponsibilities">
                        Cancel
                     </button>

                     <button
                        class="v-button v-button-md v-darkgreen"
                        (click)="saveResponsibilities()"
                        [disabled]="!isResponsibilitiesLoaded || isSavingResponsibilities">
                        <span *ngIf="!isSavingResponsibilities">Save</span>
                        <span
                           *ngIf="isSavingResponsibilities"
                           class="spinnerSave"></span>
                     </button>
                  </div>
               </div>
            </div>

            <div
               class="responsibilities-assign-panel"
               *ngIf="assignmentPanelOpen && activeResponsibilityIndex !== null">
               <div class="assign-panel-header">
                  <div>
                     <div class="assign-panel-title">Assign Members</div>
                     <div class="assign-panel-subtitle">Choose who should receive this responsibility:</div>
                  </div>

                  <button
                     type="button"
                     class="v-button v-button-sm v-white"
                     (click)="closeAssignmentPanel()">
                     CLOSE
                  </button>
               </div>

               <div class="assign-panel-preview">
                  {{ responsibilityRows[activeResponsibilityIndex]?.responsibilityText || "New responsibility" }}
               </div>

               <vc-text-input
                  [(ngModel)]="assignmentSearch"
                  placeholder="Search team member..."></vc-text-input>

               <div class="assign-team-list">
                  <label
                     class="assign-team-row"
                     [style.opacity]="teamMember.hasStarted || !teamMember.reviewType ? '0.6' : '1'"
                     *ngFor="let teamMember of getAssignableTeamMembers()">
                     <input
                        type="checkbox"
                        [disabled]="teamMember.hasStarted || !teamMember.reviewType"
                        [checked]="isAssignedToTeamMember(teamMember.revieweeId)"
                        (change)="toggleAssignedTeamMember(teamMember.revieweeId, $any($event.target).checked)" />

                     <div>
                        <div class="assign-team-name">{{ teamMember.name }}</div>
                        <span
                           *ngIf="teamMember.hasStarted"
                           class="assign-team-started">
                           Already started
                        </span>
                        <span
                           *ngIf="!teamMember.reviewType"
                           class="assign-team-started">
                           Need to select review type first
                        </span>
                     </div>
                  </label>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- Full review reference viewer -->
   <div
      class="defer-overlay"
      *ngIf="showFullReviewPreview"
      (click)="closeFullReviewPreview()">
      <div
         class="defer-dialog resp-review-lightbox"
         (click)="$event.stopPropagation()">
         <div class="responsibilities-header">
            <div class="defer-modal-title">Performance Review &mdash; All Current Questions</div>
            <button
               type="button"
               class="teamModal__close"
               aria-label="Close"
               (click)="closeFullReviewPreview()">
               <i class="fas fa-close"></i>
            </button>
         </div>
         <hr />

         <div class="resp-review-lightbox-body">
            <div
               class="resp-review-section"
               *ngFor="let section of fullReviewSections">
               <h4>{{ section.title }}</h4>
               <div
                  class="resp-review-q"
                  *ngFor="let q of section.questions"
                  [ngSwitch]="q.type">
                  <div
                     class="resp-review-subtitle-row"
                     *ngSwitchCase="'subtitle'">
                     <span class="resp-review-subtitle">{{ q.label }}</span>
                     <span
                        class="resp-mark-na-btn"
                        *ngIf="q.showMarkNotApplicable">
                        <i class="fas fa-ban"></i>
                        &nbsp;Mark Not Applicable
                     </span>
                  </div>

                  <div
                     class="resp-review-static"
                     *ngSwitchCase="'static'"
                     [innerHTML]="q.label"></div>

                  <ng-container *ngSwitchCase="'table'">
                     <div
                        class="resp-review-table-title"
                        [innerHTML]="q.label"></div>
                     <table class="resp-review-table">
                        <thead>
                           <tr>
                              <th *ngFor="let col of q.columns">{{ col }}</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td *ngFor="let col of q.columns">
                                 <textarea
                                    class="resp-table-ta"
                                    disabled></textarea>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <span class="resp-addrow-btn">Add Row</span>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                     <div class="resp-q-label">
                        <span [innerHTML]="q.label"></span>
                        <span
                           class="resp-req"
                           *ngIf="q.required">
                           *
                        </span>
                     </div>
                     <div
                        class="resp-pills"
                        *ngIf="q.options?.length">
                        <span
                           class="resp-pill"
                           *ngFor="let opt of q.options">
                           {{ opt }}
                        </span>
                     </div>
                     <textarea
                        class="resp-notes-ta"
                        *ngIf="q.type === 'textarea'"
                        disabled
                        placeholder="Additional comments..."></textarea>
                  </ng-container>
               </div>
            </div>
         </div>
      </div>
   </div>

   <!-- AI duplicate check dialog on Save -->
   <div
      class="defer-overlay"
      *ngIf="dupSaveDialog.show">
      <div
         class="defer-dialog resp-dup-dialog"
         (click)="$event.stopPropagation()">
         <div class="defer-modal-title">
            <span class="resp-dup-dialog-warn"><i class="fas fa-exclamation"></i></span>
            &nbsp;A similar question may already exist
         </div>
         <p
            class="defer-modal-subtitle"
            style="margin-top: 10px">
            Our AI check compared your new responsibility against every question currently on this review and found a close match:
         </p>
         <div
            class="resp-dup-match resp-dup-dialog-match"
            *ngFor="let match of dupSaveDialog.matches">
            <div class="resp-dup-dialog-yours">Your new responsibility: &ldquo;{{ match.text }}&rdquo;</div>
            <div>Existing question: &ldquo;{{ match.existing }}&rdquo;</div>
         </div>
         <p
            class="defer-modal-subtitle"
            style="margin-top: 12px">
            You can save it anyway, or go back and edit to avoid asking the team member the same thing twice.
         </p>
         <div style="display: flex; gap: 10px; justify-content: flex-end; margin-top: 16px">
            <button
               class="v-button v-button-md v-white"
               (click)="dupSaveDialog = { show: false, matches: [] }">
               Go back &amp; edit
            </button>
            <button
               class="v-button v-button-md v-darkgreen"
               (click)="confirmSaveDespiteDuplicates()">
               Save anyway
            </button>
         </div>
      </div>
   </div>
</ng-container>

<div
   class="teamModal-overlay"
   *ngIf="showteamModal && dash.activeTeamSubTab === 'roster'"
   (click)="closeteamModal()">
   <div
      class="teamModal"
      role="dialog"
      aria-teamModal="true"
      aria-labelledby="teamModal-title"
      (click)="$event.stopPropagation()">
      <div class="teamModal__header">
         <h2
            id="teamModal-title"
            class="teamModal__title">
            Getting started
         </h2>
         <button
            type="button"
            class="teamModal__close"
            aria-label="Close"
            (click)="closeteamModal()">
            <i class="fas fa-close"></i>
         </button>
      </div>

      <div class="teamModal__body">
         <ol class="step-list">
            <li class="step-list__item">
               <span class="step-list__number">1</span>
               <p class="step-list__text">
                  Select the appropriate
                  <strong>Review Type</strong>
                  for each team member listed below in your home hospital.
               </p>
            </li>
            <li class="step-list__item">
               <span class="step-list__number">2</span>
               <p class="step-list__text">
                  If applicable, list any significant responsibilities specific to this team member's role (that are not already covered elsewhere) to
                  be included in the self-assessment and manager review. Click
                  <strong>Manage Duties</strong>
                  to add additional responsibilities.
               </p>
            </li>
            <li class="step-list__item step-list__item--last">
               <span class="step-list__number">3</span>
               <p class="step-list__text">Once both fields are complete, the review opens for the team tember and Hospital Manager.</p>
            </li>
         </ol>

         <p class="teamModal__footnote">Complete this for all team members to ensure reviews are available when the cycle opens.</p>
      </div>

      <div class="teamModal__footer teamModal__footer--split">
         <label class="teamModal__dontshow">
            <input
               type="checkbox"
               [(ngModel)]="dontShowGettingStarted" />
            Do not show this again
         </label>

         <button
            type="button"
            class="v-button v-button-md v-darkgreen"
            (click)="closeteamModal()">
            <i class="fas fa-thumbs-up"></i>
            &nbsp; Got it
         </button>
      </div>
   </div>
</div>

<p-dialog
   [visible]="jobDescDialog().show"
   (visibleChange)="!$event ? closeJobDescDialog() : null"
   [modal]="true"
   [draggable]="false"
   [resizable]="false"
   class="job-selections"
   [style]="{ width: '520px' }"
   header="Job Descriptions Selection">
   <p style="font-weight: 400; color: #1e1d1d; font-size: 13px; margin: 0px 0 16px 0">
      Select every job description
      <strong>{{ jobDescDialog().row?.name }}</strong>
      should review and confirm on their Cross-Trained self-assessment. Each selected description appears on the review with its own checkbox.
   </p>

   <vc-spinner *ngIf="!isJobDescsLoaded"></vc-spinner>

   <div *ngIf="isJobDescsLoaded">
      <div
         *ngFor="let d of jobDescriptionOptions"
         style="display: flex; align-items: center; gap: 10px; padding: 5px 2px">
         <p-checkbox
            [binary]="true"
            [(ngModel)]="jobDescSelections[d.label]"
            [inputId]="'jd_' + d.label"
            [disabled]="isJobDescDisabled(d.label)"></p-checkbox>

         <label
            [for]="'jd_' + d.label"
            style="font-size: 14px; cursor: pointer; margin: 0">
            {{ d.label }} &nbsp; | &nbsp;
            <a
               [href]="d.url"
               target="_blank"
               rel="noopener"
               title="View job description"
               style="margin-left: auto; color: #026c6b; font-size: 12px; letter-spacing: 0.5px">
               View job description
               <span style="font-size: 16px">»</span>
            </a>
         </label>
      </div>
   </div>

   <ng-template pTemplate="footer">
      <button
         type="button"
         class="v-button v-button-md v-white"
         (click)="closeJobDescDialog()">
         Cancel
      </button>
      <button
         type="button"
         class="v-button v-button-md v-darkgreen"
         [disabled]="!isJobDescsLoaded || isSavingJobDescs"
         (click)="saveJobDescSelections()">
         {{ isSavingJobDescs ? "Saving..." : "Save" }}
      </button>
   </ng-template>
</p-dialog>

<!-- Export column-picker modal -->
<div
   *ngIf="showExportModal"
   class="export-overlay"
   (click)="closeExportModal()"></div>

<div
   *ngIf="showExportModal"
   class="export-modal">
   <div class="export-modal__header">
      <div class="export-modal__icon">
         <i class="fa fa-file-excel"></i>
      </div>
      <div class="export-modal__titles">
         <div class="export-modal__title">Export Team List</div>
         <div class="export-modal__subtitle">Choose which columns to include in your Excel export</div>
      </div>
      <button
         type="button"
         class="export-modal__close"
         title="Close"
         (click)="closeExportModal()">
         <i class="fa fa-xmark"></i>
      </button>
   </div>

   <div class="export-modal__toolbar">
      <span class="export-modal__count">
         <strong>{{ selectedExportCount }}</strong>
         of {{ exportColumns.length }} columns selected
      </span>
      <span class="export-modal__toolbar-links">
         <button
            type="button"
            (click)="setAllExportColumns(true)">
            Select all
         </button>
         <span class="export-modal__divider"></span>
         <button
            type="button"
            (click)="setAllExportColumns(false)">
            Clear all
         </button>
      </span>
   </div>

   <div class="export-modal__grid">
      <label
         class="export-col"
         *ngFor="let col of exportColumns"
         [class.export-col--selected]="col.selected">
         <input
            type="checkbox"
            [(ngModel)]="col.selected" />
         <span class="export-col__icon">
            <i
               class="fa"
               [ngClass]="col.icon"></i>
         </span>
         <span class="export-col__label">{{ col.label }}</span>
         <span class="export-col__check">
            <i class="fa fa-check"></i>
         </span>
      </label>
   </div>

   <div class="export-modal__footer">
      <button
         type="button"
         class="v-button v-button-md v-white"
         (click)="closeExportModal()">
         Cancel
      </button>
      <button
         type="button"
         class="v-button v-button-md v-green"
         [disabled]="selectedExportCount === 0"
         (click)="exportDashboardRowsXlsx()">
         <i class="fa fa-file-excel"></i>
         &nbsp;Export {{ selectedExportCount }} {{ selectedExportCount === 1 ? "Column" : "Columns" }}
      </button>
   </div>
</div>
